import { Component, OnInit, ViewChild, Input, EventEmitter, Output, AfterViewInit, ViewEncapsulation, ViewChildren, QueryList } from '@angular/core';
import { Formulario, FormularioPrefs } from '../formulario';
import { TablaPrefs, Tabla } from '../tabla';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormDialog } from '../form-dialog/';
import { FocusNextDirective } from '../directives/focus-next.directive';
import { FormButtons } from './interfaces';

@Component({
// tslint:disable-next-line: component-selector
	selector: 'tr2-grilla',
	templateUrl: './grilla.component.html',
	styleUrls: ['./grilla.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class Grilla implements OnInit, AfterViewInit {
	dialogRef: MatDialogRef<any>;
	constructor(
		private dialog: MatDialog
	) {  }

	inicializado = false;
	focusNextGuardar = null;

	@ViewChild('trgrillatabla', { static: false }) trgrillatabla: Tabla;
	// @ViewChild('trgrillapretabla', { static: false }) trgrillapretabla: Tabla;
	@ViewChild('trgrillaformulario', { static: false }) trgrillaformulario: Formulario;
	@ViewChildren(FocusNextDirective) focusElements: QueryList<FocusNextDirective>;

	/** Permite mostar el formulario por encima de la tabla (no popup) */
	@Input() formularioInline = false;

	/** Permite definir el ancho del formulario */
	@Input() colform = 's12';

	/** Permite definir el ancho de la grilla */
	@Input() coltabla = 's12';

	/** Permite definir el ancho de una columna vacia entre el formulario y la tabla */
	@Input() colvacio = 's12';

	/** Permite definir clases del contenedor principal del componente */
	@Input() clase = '';

	/** Permite refrescar la tabla al guardar o editar un registro */
	@Input() reloadTabla = true;

	/** Permite mostar el formulario ya abierto por encima de la tabla (no popup) */
	@Input() formularioInlineAllways = false;

	/** Habilita o no el formulario */
	@Input() formulario = true;

	/** Preferencias del formulario si formulario está habilitado */
	@Input() formularioPrefs: FormularioPrefs;

	/** Habilita o no la tabla */
	@Input() tabla = true;

	/** Preferencias de la tabla si tabla está habilitado */
	@Input() tablaPrefs: TablaPrefs;

	/** Habilita o no la pre-tabla */
	// @Input() pretabla = true;

	/** Preferencias de la pre-tabla si pre-tabla está habilitado */
	// @Input() pretablaPrefs: TablaPrefs;

	/** Permite que el buscador de la tabla acepte chips */
	@Input() resultadosChips = false;

	/** Permite establecer un título para el formulario */
	@Input() formtitle: string;

	/** Permite establecer un texto descriptivo o de ayuda para el formulario */
	@Input() formhint: string;

	/** Permite habilitar o no los botones del componente formulario */
	@Input() btnAccionesDefault: Boolean;

	/** Permite habilitar o no el boton agregar del componente formulario */
	@Input() btnAgregarDefault: Boolean;

	/** Permite habilitar o no el refresh de la tabla al cerrar el Dialog */
	@Input() btnRefrescar: Boolean;

	/** Permite habilitar o no los botones dpersonalizados */
	@Input() btnAccionesPersonalizados: FormButtons[] = [];

	@Output() fnchipChanges = new EventEmitter();
	@Output() fnestablecido = new EventEmitter();
	@Output() fncambiaFecha = new EventEmitter();
	@Output() fncambiaMes = new EventEmitter();
	@Output() fncambiaSelect = new EventEmitter();
	@Output() fncambiaInputtext = new EventEmitter();
	@Output() fnformReset = new EventEmitter();
	@Output() fnclickImagen = new EventEmitter();
	@Output() fndocargaImagen = new EventEmitter();


	ngOnInit() {
		this.btnAccionesDefault = (this.btnAccionesDefault) ? this.btnAccionesDefault : false;
		this.btnAgregarDefault = (this.btnAgregarDefault == false) ? false : true;
		this.btnRefrescar = (this.btnRefrescar == false) ? false : true;
		if (this.formularioPrefs && this.formularioPrefs.focusNextGuardar) {
			this.focusNextGuardar = this.formularioPrefs.focusNextGuardar;
		}
	}

	ngAfterViewInit(): void {
		this.init();
		return;
	}

	init() {
		this.initTabla();
		// this.initPreTabla();
		this.initFormulario();
	}
	initTabla() {
		this.trgrillatabla.init(this.tablaPrefs).then(() => {
			// Con esto podemos capturar cuando se seleccionó una fila
			this.trgrillatabla.seleccion.subscribe((seleccion) => {
				console.log('Se seleccionó elemento: ', seleccion);
			});

			// ejemplo de preseleccion
			// const preSeleccionar = [1, 2, 3];
			// this.trgrillatabla.preSeleccionar(preSeleccionar);
		});
	}
	// initPreTabla() {
	// 	this.trgrillapretabla.init(this.pretablaPrefs).then(() => {
	// 		// Con esto podemos capturar cuando se seleccionó una fila
	// 		this.trgrillapretabla.seleccion.subscribe((seleccion) => {
	// 			console.log('Se seleccionó elemento: ', seleccion);
	// 		});

	// 		// ejemplo de preseleccion
	// 		// const preSeleccionar = [1, 2, 3];
	// 		// this.trgrillapretabla.preSeleccionar(preSeleccionar);
	// 	});
	// }
	initFormulario() {
		if (this.formulario && this.formularioPrefs && (this.formularioInline || this.formularioInlineAllways)) {
			this.trgrillaformulario.init(this.formularioPrefs);
		}
	}
	cambiaAutocomplete(e: any) {
		this.fnestablecido.emit(e);
	}
	cambiaInputtext(e: any) {
		this.fncambiaInputtext.emit(e);
	}
	cambiaChips(e: any) {
		const valor = e[e.length - 1];
		if (this.trgrillatabla.chips && valor && !valor._deAuto) {
			this.trgrillatabla.filtraFormGroup.get('buscar').patchValue(e);
			this.fnchipChanges.emit(e);
		}
	}
	getBusqueda() {
		return this.trgrillatabla.filtraFormGroup.get('buscar').value;
	}
	cambiaFecha(e: any) {
		this.fncambiaFecha.emit(e);
	}
	cambiaMes(e: any) {
		this.fncambiaMes.emit(e);
	}
	cambiaSelect(e: any) {
		this.fncambiaSelect.emit(e);
	}
	formReset(e: any) {
		this.fnformReset.emit(e);
	}
	clickImagen(e: any) {
		this.fnclickImagen.emit(e);
	}
	docargaImagen(e: any) {
		this.fndocargaImagen.emit(e);
	}


	abrirFormulario(registro?: any): Promise<any> {
		return new Promise<void> (resolve => {
			if (this.formulario && this.formularioPrefs && !this.formularioInline && !this.formularioInlineAllways) {

				this.dialogRef = this.dialog.open(FormDialog, {
					width: '600px',
					data: {
						prefs: this.formularioPrefs,
						formtitle: this.formtitle,
						formhint: this.formhint,
						registro: registro
					}
				});

				// suscribimos para escuchar los cambios de los campos autocomplete, chips, fecha y mes
				this.dialogRef.componentInstance.fnchipChanges.subscribe((e) => {
					this.fnestablecido.emit(e);
				});
				this.dialogRef.componentInstance.fnestablecido.subscribe((e) => {
					this.fnchipChanges.emit(e);
				});
				this.dialogRef.componentInstance.fncambiaFecha.subscribe((e) => {
					this.fncambiaFecha.emit(e);
				});
				this.dialogRef.componentInstance.fncambiaMes.subscribe((e) => {
					this.fncambiaMes.emit(e);
				});
				this.dialogRef.componentInstance.fncambiaSelect.subscribe((e) => {
					this.fncambiaSelect.emit(e);
				});
				this.dialogRef.componentInstance.fncambiaInputtext.subscribe((e) => {
					this.fncambiaInputtext.emit(e);
				});
				this.dialogRef.componentInstance.fnformReset.subscribe((e) => {
					this.fnformReset.emit(e);
				});

				this.dialogRef.afterClosed().subscribe(result => {
					console.log(this.btnRefrescar);
					if (this.reloadTabla && result && this.btnRefrescar) {
						this.trgrillatabla.refreshTable();
						// this.trgrillapretabla.refreshTable();
					}
					resolve(result);
				});
			} else {
				resolve();
			}
		})
	}

	submit() {
		this.trgrillaformulario.onSubmit().then((result) => {
			if (this.reloadTabla && result) {
				this.trgrillatabla.refreshTable();
				// this.trgrillapretabla.refreshTable();
			}
		});
	}
	recargarTabla() {
		this.trgrillatabla.refreshTable();
	}
	// recargarPreTabla() {
	// 	this.trgrillapretabla.refreshTable();
	// }
	llenarTabla(datos: any) {
		this.trgrillatabla.llenarTabla(datos);
	}
	// llenarPreTabla(datos: any) {
	// 	this.trgrillapretabla.llenarTabla(datos);
	// }
	limpiarFormulario() {
		this.trgrillaformulario.reset();
	}
	getResetOnSubmit() {
		return this.trgrillaformulario.resetOnSubmit;
	}
	cargarDatos(registro: any) {
		this.trgrillaformulario.cargaDatos(registro);
	}
}
